import { render, staticRenderFns } from "./iconList.vue?vue&type=template&id=21ba0384&scoped=true&"
import script from "./iconList.vue?vue&type=script&lang=js&"
export * from "./iconList.vue?vue&type=script&lang=js&"
import style0 from "./iconList.vue?vue&type=style&index=0&id=21ba0384&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ba0384",
  null
  
)

export default component.exports